import React, { useMemo } from "react";
import { Breadcrumb } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import { useLocation, history, useModel } from "@umijs/max";
import routes from "../../../config/routes";
import "./index.less";

interface RouteItem {
  path?: string;
  mainPath?: string;
  name?: string;
  routes?: RouteItem[];
  redirect?: string;
  layout?: boolean;
  component?: string;
  hideInMenu?: boolean;
}

interface BreadcrumbItem {
  title: string | React.ReactNode;
  path?: string;
}

const CustomBreadcrumb: React.FC = () => {
  const {globalData} = useModel("contactModel");
  const location = useLocation();

  // 递归查找路由路径
  const findRoutePath = (
    routes: RouteItem[],
    targetPath: string,
    parentPaths: RouteItem[] = []
  ): RouteItem[] | null => {
    for (const route of routes) {
      const currentPath = [...parentPaths, route];

      // 匹配当前路径
      if (route.path === targetPath) {
        return currentPath;
      }

      // 递归查找子路由
      if (route.routes) {
        const found = findRoutePath(route.routes, targetPath, currentPath);
        if (found) return found;
      }
    }
    return null;
  };

  // 生成面包屑数据
  const breadcrumbItems = useMemo(() => {
    const currentPath = location.pathname;
    const routePath = findRoutePath(routes, currentPath);

    const items: any[] = [];

    // 添加首页图标
    items.push({
      title: <HomeOutlined style={{ fontSize: 16 }} />,
      onClick: () => history.push("/"),
    });

    if (!routePath) return items;

    routePath.forEach((route, index) => {
      // 过滤掉不需要显示的路由
      if (
        route.layout === false ||
        !route.name ||
        route.path === "/" ||
        route.redirect
      ) {
        return;
      }

      const isLast = index === routePath.length - 1;

      // 处理 href 逻辑
      let href: string | undefined;

      if (isLast && route.hideInMenu) {
        // 获取父级路由
        const parentRoute = routePath[index - 1];

        if (parentRoute?.routes) {
          // 在同级路由中查找当前路由的索引
          const currentRouteIndex = parentRoute.routes.findIndex(
            (r) => r.path === route.path
          );

          if (currentRouteIndex > 0) {
            // 从当前路由前面往前查找，找到第一个 hideInMenu 不为 true 的路由
            for (let i = currentRouteIndex - 1; i >= 0; i--) {
              const siblingRoute = parentRoute.routes[i];
              if (!siblingRoute.hideInMenu && siblingRoute.path) {
                let hrefPath = siblingRoute.path;
                items.push({
                  title: siblingRoute.name,
                  onClick: hrefPath ? () => history.push(hrefPath) : undefined,
                });
                break;
              }
            }
          }
        }
      }
      href = route.path;
      //========================  特殊处理 ====================== 
      console.log(globalData,'path')
      if (isLast && currentPath.includes("/contract/")) { 
        if (globalData && globalData.ppath) {
          items.push({
            title: globalData.pname,
            onClick: () => history.push(globalData.ppath),
          });
        }
      }

      //======================  特殊处理结束 ===========================
      // 如果是第一个层级且没有 path，则获取子级第一个可用路由
      if (index === 0 && route.routes) {
        // 查找第一个 hideInMenu 不为 true 且 path 不为空的子路由
        const firstAvailableChild = route.routes.find(
          (childRoute) => !childRoute.hideInMenu && childRoute.path
        );
        if (firstAvailableChild?.path) {
          href = firstAvailableChild.path;
        }
      }
      items.push({
        title: route.name,
        onClick: href ? () => history.push(href) : undefined,
      });
    });

    return items;
  }, [location.pathname]);

  // 至少要有首页图标，否则不渲染
  if (breadcrumbItems.length <= 1) {
    return null;
  }

  return (
    <div
      style={{
        padding: "16px 0",
        height: "56px",
        fontSize: "14px",
      }}
    >
      <Breadcrumb items={breadcrumbItems} className="custom-breadcrumb" />
    </div>
  );
};

export default CustomBreadcrumb;
